import BoatReNewRegistrationProcess from "../../Components/BoatRegistration/BoatReNewRegistrationProcess";
import { useGet } from "../../Hooks/useFetch";
import { useEffect } from "react";
import DataLoader from "../../Components/DataLoader";
import AlertMessage from "../../Components/AlertMessage";
import { decryptText } from "../../Helpers/Helper";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { Box, Button, Stack, Typography } from "@mui/material";
import SearchOffIcon from "@mui/icons-material/SearchOff";

const BoatNewReRegistrationForm = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [resKey, err, isLoadingKey, apiGetKey, abtKey] = useGet();

  const hasState = location.state !== null && location.state !== undefined;
  const pcCraft = location.state?.pcCraft;

  useEffect(() => {
    if (!hasState) {
      navigate("/boatnewreregistration", { replace: true });
      return;
    }
    if (pcCraft) {
      apiGetKey("/api/pcraft/PayWayKey");
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (!hasState) {
    return null;
  }

  if (!pcCraft) {
    return (
      <div className="br-container new-re-regi-result-container">
        <Box
          sx={{
            background: "#fff",
            boxShadow: "0 6px 24px rgba(0,0,0,0.08)",
            borderRadius: "16px",
            border: "1px solid #e9ecef",
            borderTop: "4px solid #337ab7",
            p: { xs: 3, sm: "2.5rem" },
            maxWidth: 520,
            width: "100%",
          }}
        >
          <Stack spacing={2}>
            <Stack direction="row" spacing={1.5} alignItems="center">
              <SearchOffIcon sx={{ color: "warning.main", fontSize: 32 }} />
              <Typography variant="h6" fontWeight={600}>
                No Vessel Found
              </Typography>
            </Stack>
            <Typography variant="body1" color="text.secondary">
              No matching vessel was found with that Rego No or Personalised ID.
            </Typography>
            <Stack direction="row" spacing={2} sx={{ pt: 1 }}>
              <Button
                component={Link}
                to="/boatnewreregistration"
                variant="contained"
                size="small"
              >
                Search Again
              </Button>
              <Button
                component={Link}
                to="/boatregistration"
                variant="outlined"
                size="small"
              >
                Go to New Boat Registration
              </Button>
            </Stack>
          </Stack>
        </Box>
      </div>
    );
  }

  return (
    <>
      {!isLoadingKey ? (
        !err ? (
          <BoatReNewRegistrationProcess
            payWayPublicKey={decryptText(
              resKey,
              process.env.REACT_APP_Encrypt_Key,
              process.env.REACT_APP_Encrypt_IV,
            )}
            pcCraft={pcCraft}
            hullCodes={pcCraft?.hullCodes}
          />
        ) : (
          <AlertMessage message={err} />
        )
      ) : (
        <div className="dataLoader-container">
          <DataLoader isLoading={isLoadingKey} />
        </div>
      )}
    </>
  );
};

export default BoatNewReRegistrationForm;
